<template>
  <div class="container">
    <h1>Bubbelsortering</h1>

    <p>Tidskomplexitet i värsta fall: O(n<sup>2</sup>)<br>
        Tidskomplexitet i bästa fall: O(n)</p>

    <div class="utanförSiffra" v-for="(item, index) in lista" :key="index">
    <div class="sifferbehållare" >
       <div class="siffra" :id="index">
           {{ item }}
       </div>

   </div>
   [{{index}}]
   <div class="m"><b>m</b></div>
   <div class="n"><b>n</b></div>
</div>


<div id="klart" style="color:black;">Listan är sorterad</div>

<br><br>


<!--button v-on:click="sortera2()">Bubbel-Sortera manuellt</button-->
<div id="knapprad">
<button v-on:click="auto()">&#9654;</button>

<button v-on:click="pause()"> &#9208; </button>

<button v-on:click="blanda()">Blanda</button>
</div>

<br>
<div id="kodfält">

public void Bubbelsortera (int [] lista)<br>
{<br>
     {{'\xa0 \xa0'}} for ( int m=lista.Length-1 ; m>0 ; m--) <br>
     {{'\xa0 \xa0'}} {<br>
     {{'\xa0 \xa0 \xa0 \xa0'}} for ( int n=0 ; n&#60;m ; n++) <br>
     {{'\xa0 \xa0 \xa0 \xa0'}} {<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} if ( lista[n] > lista [n+1] )<br>

    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} {<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} int temp = lista [n];<br>
        {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} lista [n] = lista [n+1];<br>
        {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} lista [n+1] = temp;<br>
{{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} }<br>
{{'\xa0 \xa0 \xa0 \xa0'}} }<br>
{{'\xa0 \xa0'}} }<br>
}<br>


</div>
<!--div id="källa"><i>Programmering 1</i>, Magnus Lilja, Ulrik Nilsson, Gleerups 2012, s.193</div-->
<br>
  </div>


</template>

<script>
export default {
  name: 'Bubblesortering',
  props: {
    msg: String,
    lista : Array
    //n:Number,
    //m:Number //lista.length-1
},
data() {
    return {
        n:0,
        m:6,
        sune:Function
    }


},
methods: {
    sortera: function() {
        var temp=0;
        //var sune =5;
        for (let m=this.lista.length-1; m>0; m-- ) {

            for (let n=0; n<m; n++) {

                if(this.lista[n]>this.lista[n+1]) {
                    temp = this.lista[n];
                    this.lista[n]=this.lista[n+1];
                    this.lista[n+1] = temp;
                    this.uppdatera();

                }
            }
        }
    },
    sortera2:function() {
        var temp;



        if (this.m==0){
            document.getElementById('klart').style.display="block";
            document.getElementById('0').parentNode.style.backgroundColor="#bbb";
            document.getElementById('1').parentNode.style.backgroundColor="#bbb";
            document.getElementById('1').parentElement.parentElement.children[1].style.color = "lightpink";
            document.getElementById('0').parentElement.parentElement.children[2].style.color = "lightpink";
            clearInterval(this.sune);

            return
        }


        if(this.lista[this.n]>this.lista[this.n+1]) {

            temp = this.lista[this.n];
            this.lista[this.n]=this.lista[this.n+1];
            this.lista[this.n+1] = temp;
        }



        if (this.n<this.m){
            this.n++;
            this.uppdatera();
            this.uppdatera2();
        } else {
            if(this.m>1) {
                this.m--;
                this.n=0;
                this.allamörka();
                this.uppdatera2();
            } else {
                this.allamörka();
                this.m--;

            }

        }

    },
    uppdatera: function() {
        this.lista.forEach((item, i) => {

            var temp= document.getElementById(i);

            if (i== this.n  || i == (this.n - 1) ) {
                temp.parentElement.style.backgroundColor = "#fff";

            } else {

                temp.parentElement.style.backgroundColor = "#bbb";

            }
                        setTimeout(function(){
            temp.innerHTML = item;
        }, 500);


        });

    },

    uppdatera2: function() {
        this.lista.forEach((item, i) => {

            var temp= document.getElementById(i);


            if (this.n==i+1) {

                temp.parentElement.parentElement.children[2].style.color = "black";
            } else {
                temp.parentElement.parentElement.children[2].style.color = "lightpink";
            }

            if (this.m==i) {

                temp.parentElement.parentElement.children[1].style.color = "black";
            } else {
                temp.parentElement.parentElement.children[1].style.color = "lightpink";
            }




        });

    },

    allamörka: function() {
        this.lista.forEach((item, i) => {

            var temp= document.getElementById(i);
            temp.parentElement.style.backgroundColor = "#bbb";



        });

    },


    blanda:function() {
        document.getElementById('klart').style.display="none";
        this.n=0;
        this.m=6;
        this.lista.forEach((item,i )=> {
            this.lista[i]= Math.floor(Math.random() * 100);
            var temp= document.getElementById(i);
            temp.innerHTML=this.lista[i];
            temp.parentElement.style.backgroundColor = "#bbb";
        })
    },

    pause: function() {
        clearInterval(this.sune);
    },
    auto: function() {
        var that=this;
        this.sune = setInterval(function() {
            that.sortera2()}, 1000);
    }
},
created() {
    document.title = 'Bubbelsortering';
},
mounted() {
    this.blanda();
},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin: 0px;
  padding: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#källa {
    font-size: 0.8em;
}

.sifferbehållare {

    border-radius: 50px;
    background-color: #bbb;
    border-style: solid;
    /*display: inline-block;*/
    height: 5em;
    width: 5em;
    transition: background-color 0.5s;
}

.utanförSiffra {
    display: inline-block;
}



.siffra {
    font-size: 3em;
    padding: 10px;

}
.container {
    min-height: 100vh;
    background-color: lightpink;


}

#klart {
    display:none;
}

.m{
    color:lightpink;
    transition: color 1s;
    font-family: "Times New Roman", Times, serif;
}

.n{
    color:lightpink;
    transition: color 1s;
    font-family: "Times New Roman", Times, serif;
}

#kodfält {
    display: inline-block;
    text-align: left;
    background-color: lightgrey;
    padding: 1em;
    font-family: 'Courier New', monospace;
}
</style>
